import React, { CSSProperties } from "react";

interface ContactFormExportProps {
  formAction?: string;
  submitText?: string;
  successMessage?: string;
  showPhone?: boolean;
  showSubject?: boolean;
  backgroundColor?: string;
  borderRadius?: number;
  padding?: number;
}

export const ContactFormExport: React.FC<ContactFormExportProps> = ({
  formAction = "#",
  submitText = "Send Message",
  successMessage = "Thank you! We will contact you soon.",
  showPhone = true,
  showSubject = false,
  backgroundColor = "#ffffff",
  borderRadius = 12,
  padding = 32,
}) => {
  const containerStyle: CSSProperties = {
    backgroundColor,
    padding: `${padding}px`,
    borderRadius: `${borderRadius}px`,
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
  };

  const inputStyle: CSSProperties = {
    width: "100%",
    padding: "12px 16px",
    border: "1px solid #d1d5db",
    borderRadius: "8px",
    fontSize: "1rem",
    outline: "none",
    boxSizing: "border-box",
  };

  const labelStyle: CSSProperties = {
    display: "block",
    fontWeight: 500,
    marginBottom: "8px",
    color: "#374151",
  };

  const fieldStyle: CSSProperties = {
    marginBottom: "20px",
  };

  return (
    <div style={containerStyle} className="contact-form" data-success-message={successMessage}>
      {/* Success Message - hidden by default, shown via JS */}
      <div className="form-success" style={{ display: "none", textAlign: "center", padding: "32px 0" }}>
        <span style={{ fontSize: "2.25rem", display: "block", marginBottom: "16px" }}>✅</span>
        <span style={{ color: "#16a34a", fontWeight: 500 }}>{successMessage}</span>
      </div>
      <form action={formAction} method="POST" className="form-content">
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
          <div style={fieldStyle}>
            <label style={labelStyle}>Name *</label>
            <input type="text" name="name" required placeholder="Your name" style={inputStyle} />
          </div>
          <div style={fieldStyle}>
            <label style={labelStyle}>Email *</label>
            <input type="email" name="email" required placeholder="your@email.com" style={inputStyle} />
          </div>
        </div>

        {showPhone && (
          <div style={fieldStyle}>
            <label style={labelStyle}>Phone</label>
            <input type="tel" name="phone" placeholder="Your phone number" style={inputStyle} />
          </div>
        )}

        {showSubject && (
          <div style={fieldStyle}>
            <label style={labelStyle}>Subject</label>
            <input type="text" name="subject" placeholder="How can we help?" style={inputStyle} />
          </div>
        )}

        <div style={fieldStyle}>
          <label style={labelStyle}>Message *</label>
          <textarea
            name="message"
            required
            rows={5}
            placeholder="Your message..."
            style={{ ...inputStyle, resize: "vertical", minHeight: "120px" }}
          />
        </div>

        <button
          type="submit"
          style={{
            width: "100%",
            padding: "12px 24px",
            backgroundColor: "var(--color-primary, #3b82f6)",
            color: "white",
            border: "none",
            borderRadius: "8px",
            fontSize: "1rem",
            fontWeight: 500,
            cursor: "pointer",
          }}
        >
          {submitText}
        </button>
      </form>
    </div>
  );
};
